/* eslint-disable react-hooks/exhaustive-deps */
import { consumirServicioEncirptacion } from "api";
import BreadCurmb from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import SimpleContainer from "components/InputsMex/containers/SimpleContainer";
import { DropDownFilter } from "components/InputsMex/inputs";
import Page from "components/Page";
import {
  ambienteAplicacion,
  urlEmisionPoliza,
  urlResumenCotizadorMex,
  urlTarifacionCotizadorMex,
} from "constants/urls";
import { useNavbarContext } from "contexts/NavbarContext";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import useParametrosPago from "redux/hooks/useParametrosPago";
import { PASOS_BREADCRUMBS } from "utils/constants";
import Loading from "wrappers/Loading";
import OpcionesPago from "./OpcionesPago";

const ResumenPago = ({
  history,
  addWarningToast,
  dataUsuario,
  qParams,
  productoCodigoCore,
  urlGoTo,
  urlBackTo,
  procesarInfo = false,
  setShowInfoModal = () => {},
  ...props
}) => {
  useNavbarContext(productoCodigoCore);

  const [showOpciones, setshowOpciones] = useState(false);
  const [cotizacion, setCotizacion] = useState(null);

  const [plan, setPlan] = useState({});

  const [datosTarifacion, setDatosTarifacion] = useState(null);
  const [isRecalculando, setRecalcular] = useState(false);
  const [bloqueoError, setBloqueoError] = useState(true);

  const [seleccionMeses, setseleccionMeses] = useState(false);

  const [pagoRealizado, setPagoRealizado] = useState(false);

  const { fetchParametros, parametros, setCombos, ...stateParametrosPago } =
    useParametrosPago(productoCodigoCore);

  const methods = useForm({ mode: "onChange" });
  const { getValues } = methods;

  useEffect(() => {
    if (!qParams?.idCotizacion) {
      history.replace("/");
      history.push("/");
    }
  }, [qParams?.idCotizacion]);

  const tarifar = ({ idPlazo, formaPago, labelPlazo }) => {
    if (!formaPago) return;
    setRecalcular(true);

    const Data = {
      cotCodigo: qParams?.idCotizacion,
      ambiente: ambienteAplicacion,
      prodCodigo: productoCodigoCore,
      usuCotiza: { usuCodigo: dataUsuario.cliCodigoCore },
      formaPago,
      idPlazo,
      labelPlazo,
      codigoUsuario: "",
    };

    consumirServicioEncirptacion(urlTarifacionCotizadorMex, Data)
      .then((res) => {
        if (res.transaccion) {
          setDatosTarifacion(res?.datosTarifacion);
          setBloqueoError(false);
          if (res?.datosTarifacion?.permitirEmitir === false) {
            setBloqueoError(true);
            addWarningToast(res?.datosTarifacion?.msgError);
          }
        } else {
          setBloqueoError(true);
          addWarningToast(
            "Ocurrio un error Calculando, seleccione otro tipo de pago o refresque la página"
          );
        }
      })
      .catch((err) => {
        setBloqueoError(true);
        addWarningToast(
          "Ocurrio un error Calculando, seleccione otro tipo de pago o refresque la página"
        );
      })
      .finally(() => setRecalcular(false));
  };

  const parseToComponent = (plan) => {
    const valoresCoberturas = {};
    for (const cob of plan?.coberturas) {
      valoresCoberturas[cob?.codigoCore] = `
                <div class='row col-12 d-felx flex-wrap justify-content-between'>
                    <div class='col-12'><h6 class='text-center'>${cob?.sumaAsegurada} ${plan?.monedaSimbolo}</h6></div>
                </div>`;
    }
    return {
      nombreOpcion: plan.producto,
      textCabecera: "Prima total anual",
      precioFormatoMensual: plan?.precioFormatoMensual || null,
      primaTotal: plan.precioFormatoAnual,
      etiquetas: plan?.coberturas.map((cob) => ({
        id: cob?.codigoCore,
        label: cob?.descripcion,
      })),
      ...valoresCoberturas,
    };
  };

  const init = async () => {
    const DataResumen = {
      cotDatos: {
        ambiente: ambienteAplicacion,
        cotCodigo: qParams?.idCotizacion,
      },
    };

    const data = await consumirServicioEncirptacion(urlResumenCotizadorMex, DataResumen);

    if (data?.transaccion) {
      if (procesarInfo !== false) {
        data.cotConsulta = procesarInfo(data?.cotConsulta);
      }
      setCotizacion(data?.cotConsulta);
      const resumen = data?.cotConsulta;
      const totales = Array.isArray(resumen?.totGenerales) ? resumen?.totGenerales?.[0] : resumen?.totGenerales;

      setPagoRealizado(!!resumen?.pagoRealizado);
      setDatosTarifacion(totales);
      methods.setValue("correo", resumen?.carContratante?.usuCorreo || "");

      tarifar({
        formaPago: totales?.formaPago || "contado",
        idPlazo: totales?.idPlazo || "1",
        labelPlazo: totales?.labelPlazo || "CONTADO",
      });

      setPlan(resumen?.prodDatos[0]);
      if (!resumen?.prodDatos[0]?.planSeleccionado) {
        let paqueteSeleccionado = resumen?.prodDatos[0]?.paquetes?.find((paquete) => {
          return paquete?.planes?.some((plan) => plan.uid === resumen?.prodDatos[0]?.plan?.uid);
        });
        setPlan({
          planes: paqueteSeleccionado?.planes,
          planSeleccionado: parseToComponent(resumen?.prodDatos[0]?.plan),
        });
      }
    }
    setLoading(false);
  };
  useEffect(() => {
    setLoading(true);
    fetchParametros();
    init();
  }, []);

  useEffect(() => {
    if (parametros && datosTarifacion) {
      setCombos({
        formaPago: datosTarifacion?.formaPago,
        idPlazo: datosTarifacion?.idPlazo,
        setshowOpciones,
        reset: methods.reset,
      });
    }
  }, [parametros, datosTarifacion]);

  const onSubmit = async (data) => {
    setLoading(true);
    const Data = {
      datosCotizador: {
        ambiente: ambienteAplicacion,
        cotPasoCodigo: "crearPoliza",
        prodCodigo: productoCodigoCore,
        cotCodigo: qParams?.idCotizacion,
      },
    };
    const res = await consumirServicioEncirptacion(urlEmisionPoliza, Data);
    if (res?.transaccion && res?.catalogo?.idPoliza) {
      //history.replace(`${urlGoTo}?idPoliza=${res?.catalogo?.idPoliza}`);
      history.replace(`${urlGoTo}?idPoliza=${res?.catalogo?.idPoliza}&ramo=${productoCodigoCore}&idCot=${qParams?.idCotizacion}`);
    }
    setLoading(false);
  };

  const onSubmitError = (errors) => {
    stateParametrosPago.error && addWarningToast(stateParametrosPago.error);
  };

  const handleRegresar = () => {
    history.push(`${urlBackTo}?idCotizacion=${qParams.idCotizacion}`);
  };

  const onChangeFormPago = (value) => {
    if (value.onChange === "recalcular") {
      tarifar({
        idPlazo: value.id,
        formaPago: value.tipo,
        labelPlazo: value.label,
      });

      setseleccionMeses(false);
    }
    setshowOpciones(value?.mostrarSubopciones);
  };
  const onChangePlazo = (value) => {
    setseleccionMeses(true);
    const formaPago = getValues("formaPago");
    tarifar({
      idPlazo: value.ID,
      formaPago: formaPago.tipo,
      labelPlazo: value.Name,
    });
  };

  const stripColors = ["#C0E7F7", "#F2B773", "#B598E3", "#9ADDD8"];

  const [loading, setLoading] = useState(false);

  const getPlanIndex = (index) => {
    if (index > stripColors.length) {
      return getPlanIndex(index - 4);
    }
    return index;
  };

  return (
    <>
      <Loading loading={loading}>
        <div className='cr-content'>
          <Page>
            <BreadCurmb {...PASOS_BREADCRUMBS[productoCodigoCore].breadCrumb} />
            <BreadCrumbPasosV2
              {...PASOS_BREADCRUMBS[productoCodigoCore].breadCrumbPasosCotizacion[4]}
              styleimg='height200px mr-3'
              pasos={PASOS_BREADCRUMBS[productoCodigoCore]?.pasosCotizacion}
            />
            <div className='row gap-3 m-2'>
              <div className='col-md-6'>
                <div className='border p-4'>
                  <div className='col text-center m-2'>
                    <h3 className='font-mex'>¡Has elegido!</h3>

                    <div className='row justify-content-center mt-3 mb-5'>
                      <div className='col-11 col-md-8 border-mex-ap text-center py-4'>
                        <div
                          className='text-center font-20px w-100'
                          style={{
                            backgroundColor:
                              stripColors[
                                (getPlanIndex(
                                  plan?.planes?.indexOf(
                                    plan?.planes?.find(
                                      (plan) =>
                                        plan?.seleccion === true || plan?.seleccionado === true
                                    )
                                  ) + 1
                                ) ?? 1) - 1
                              ],
                            paddingBottom: "0.5rem",
                            paddingTop: "0.3rem",
                            margin: "0 0 0 0 ",
                            paddingLeft: "0",
                            paddingRight: "0",
                          }}>
                          <h4 className='font-mex text-mex mt-2'>
                            {plan?.planSeleccionado?.nombreOpcion}
                          </h4>
                        </div>
                        <h2 className='font-mex'>{plan?.planSeleccionado?.primaTotal}</h2>
                      </div>
                    </div>
                  </div>
                  {plan?.planSeleccionado?.etiquetas?.map((etiqueta, index) => (
                    <div className='col-12 row d-flex flex-wrap' key={index}>
                      <div className='col-7 align-self-center'>
                        <p
                          className='font-source-sans-regular'
                          style={{ fontSize: "20px", fontWeight: "100" }}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: `${
                                etiqueta?.titulo === true
                                  ? "<b>" + etiqueta?.label + "</b>"
                                  : etiqueta?.label
                              } <div class='text-justify'>${
                                etiqueta?.texto ? etiqueta.texto : ""
                              }</div>`,
                            }}
                            onClick={() => etiqueta?.onClick && etiqueta?.onClick(setShowInfoModal)}
                          />
                        </p>
                      </div>
                      <div className='col-5 align-self-center text-right'>
                        <p className='' style={{ fontSize: "20px" }}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                etiqueta.id === "codigoRetroactividad"
                                  ? plan?.planes[0]?.popUp?.find((re) => re.seleccion === true)
                                      ?.retroactividad
                                  : etiqueta.id === "deducibleValor"
                                  ? plan?.planSeleccionado?.deducibleValor
                                  : plan?.planSeleccionado[etiqueta.id],
                            }}
                          />
                        </p>
                      </div>
                    </div>
                  ))}

                  <FormProvider {...methods}>
                    <form>
                      <div className='row'>
                        <div className='col-xl-6'>
                          <SimpleContainer
                            name='formaPago'
                            label='Opción de pago'
                            helpText={
                              (stateParametrosPago.loading && "Cargando formas de pago...") ||
                              ((!parametros?.formasPago || parametros?.formasPago?.length === 0) &&
                                "No tiene formas de pago configuradas")
                            }>
                            <DropDownFilter
                              name='formaPago'
                              filter={false}
                              options={parametros?.formasPago || []}
                              onChangeFn={onChangeFormPago}
                              loading={stateParametrosPago.loading}
                              disabled={pagoRealizado || isRecalculando}
                              loadingText={stateParametrosPago?.loading && "Cargando..."}
                            />
                          </SimpleContainer>
                        </div>

                        {showOpciones && (
                          <div className='col-xl-6'>
                            <SimpleContainer label='Elije cuántos meses' name='idPlazo'>
                              <DropDownFilter
                                name='idPlazo'
                                filter={false}
                                rules={{ required: "Obligatorio" }}
                                options={parametros.plazos}
                                onChangeFn={onChangePlazo}
                                disabled={pagoRealizado || isRecalculando}
                                loading={stateParametrosPago?.loading}
                              />
                            </SimpleContainer>
                          </div>
                        )}
                      </div>
                    </form>
                  </FormProvider>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='border p-4 position-relative h-100 d-flex'>
                  <div className='w-100 mt-5'>
                    <OpcionesPago
                      loading={isRecalculando}
                      datosTarifacion={datosTarifacion}
                      idCotizacion={qParams.idCotizacion}
                      correo={cotizacion?.carContratante?.usuCorreo ?? ""}
                      disablebtn={showOpciones && !seleccionMeses}
                      userIsLoggedIn={!!dataUsuario?.userIsLoggedIn}
                      productoCodigoCore={productoCodigoCore}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='row justify-content-center my-5'>
              <div className='col-11 col-sm-5 col-md-3 col-xl-2'>
                <button
                  className='btn btn-atras-api'
                  disabled={pagoRealizado}
                  onClick={handleRegresar}>
                  Atrás
                </button>
              </div>
              <div className='col-11 col-sm-5  col-md-3 col-xl-2'>
                <button
                  disabled={bloqueoError}
                  className='btn btn-siguiente-api'
                  type='button'
                  onClick={methods.handleSubmit(onSubmit, onSubmitError)}>
                  Siguiente
                </button>
              </div>
            </div>
          </Page>
        </div>
      </Loading>
    </>
  );
};

export default ResumenPago;
